<template lang='pug'>
  .terms-policy.component
    p.terms
      | {{ $t("By continuing, you agree to BlueFaucet's") }}
      router-link.link(:to='{ name: "terms" }') {{ $t("Terms of Services") }}
    p.policy
      | {{ $t("and acknowledge BlueFaucet's") }}
      router-link.link(:to='{ name: "privacy" }') {{ $t('Privacy Policy') }}

    bf-dialog#terms-dialog(v-show='show.terms' @close='show.terms = false')
</template>

<script>
  export default {
    name: 'terms-policy.component',

    data() {
      return {
        show: { terms: false }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .terms-policy
    text-align center
    font-size .8em
    margin-top 32px
    .link
      margin-left .5em
      font-weight bold
      color var(--clr-blue)
      text-decoration underline
</style>
